import React from 'react';
import { exampleCommands } from '../data/mock';

const CommandShowcase = () => {
  return (
    <section className="command-showcase-section">
      <div className="command-showcase-container">
        <div className="command-showcase-header">
          <h3 className="command-showcase-title">Just talk. We understand.</h3>
          <p className="command-showcase-subtitle">No charts, no jargon. Just natural language.</p>
        </div>
        
        <div className="command-examples">
          {exampleCommands.map((command, idx) => (
            <div key={idx} className="command-example" style={{ animationDelay: `${idx * 0.2}s` }}>
              <span className="command-quote">"</span>
              <span className="command-text">{command}</span>
              <span className="command-quote">"</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CommandShowcase;
